import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

import { urlMainAPI } from "@/global";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMenuVisible: false,
    showWait: false,
    token: null,
    user: null,
    system: null,
    msg: "",
    dt1: null,
    dt2: null,
    infoReport: {
      show: false,
    },
    xml: null,
    mapList: null,
    rotationScreen: false,
    reliability: {
      pgdi: false,
      a: 0,
      b: 0,
      c: 0,
    },
    isOnlineReady: false,
    isOnlineRunning: false,
    autonomousMode: false,
    activeModel: null,
    triggerActive: 0,
    changingStatus: 0,
    maintenance: false,
    msgBoxState: false,
    tokenMaxTime: "8",
    unitName: null,
    flowchartStructure: null,
    scenarioName: "Não informado",
    canUpdateFormLoss: {},
    systemMessages: null,
    intervals: {},
  },
  mutations: {
    toggleMenu(state, isVisible) {
      if (!state.user) {
        state.isMenuVisible = false;
        return;
      }

      if (isVisible === undefined) {
        state.isMenuVisible = !state.isMenuVisible;
      } else {
        state.isMenuVisible = isVisible;
      }
    },
    setIsOnlineReady(state, isOnlineReady) {
      state.isOnlineReady = isOnlineReady;
    },
    setIsOnlineRunning(state, isOnlineRunning) {
      state.isOnlineRunning = isOnlineRunning;
    },
    setAutonomousMode(state, autonomousMode) {
      state.autonomousMode = autonomousMode;
    },
    setActiveModel(state, activeModel) {
      state.activeModel = activeModel;
    },
    setTriggerActive(state, triggerActive) {
      state.triggerActive = triggerActive;
    },
    setChangingStatus(state, changingStatus) {
      state.changingStatus = changingStatus;
    },
    setMaintenance(state, maintenance) {
      state.maintenance = maintenance;
    },
    setShowWait(state, showWait) {
      // console.log('showWait: ' + showWait);
      state.showWait = showWait;
    },
    setXML(state, xml) {
      state.xml = xml;
    },
    setMapList(state, list) {
      state.mapList = list;
    },
    setRotationScreen(state, rotationScreen) {
      state.rotationScreen = rotationScreen;
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        /* eslint-disable */
        //axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
        state.isMenuVisible = true;
      } else {
        //delete axios.defaults.headers.common["Authorization"];
        state.isMenuVisible = false;
      }
    },
    setSystem(state, system) {
      // console.log('Store - System: ', system)
      state.system = system;
    },
    setToken(state, token) {
      if (token) {
        state.token = token;
        // console.log("state.token: " + state.token);
        axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
      } else {
        delete axios.defaults.headers.common["Authorization"];
      }
    },
    setMsg(state, msg) {
      // if (msg) {
      state.msg = msg;
      // }
    },
    setMsg2(state, json) {
      // console.log("entrou store - json reliability - monitoramento")
      // console.log(json)
      if (json) {
        state.reliability = json;
      }
    },
    setDt1(state, json) {
      if (json) state.dt1 = json;
    },
    setDt2(state, json) {
      if (json) state.dt2 = json;
    },
    setInfoReport(state, json) {
      if (json) state.infoReport = json;
    },
    setTokenMaxTime(state, maxTime) {
      state.tokenMaxTime = maxTime;
    },
    setMsgBoxState(state, value) {
      state.msgBoxState = value;
    },
    setFlowchartStructure(state, FlowChart) {
      state.flowchartStructure = FlowChart;
    },
    setUnitName(state, unitName) {
      state.unitName = unitName;
    },
    setScenarioName(state, scenarioName) {
      state.scenarioName = scenarioName;
    },
    clear(state) {
      Object.keys(state).forEach((o) => {
        state[o] = null;
      });
    },
    setCanUpdateFormLoss(state, newData) {
      state.canUpdateFormLoss = newData;
    },
    setSystemMessages(state, messages) {
      if(!state.systemMessages) {
          state.systemMessages = []
      }

      // Mantém as mensagens com categoria 'fixo' (normalmente adicionadas manualmente)
      state.systemMessages = state.systemMessages.filter(m => m.categories.indexOf('Fixo') >= 0).concat(messages)
    },
    addSystemMessage(state, message) {
        if(state.systemMessages) {
            let list = state.systemMessages.filter(m => 
                m.type != message.type
                && m.title != message.title
                && m.subtitle != message.subtitle
            );
            list.unshift(message)
            state.systemMessages = list;
        } else {
            state.systemMessages = [message]
        }
    },
  },
  actions: {
    // setShowWaitAsync({commit}, showWait){
    //   console.log('showWaitAsync: ' + showWait);
    //   commit("setShowWait", showWait)
    // },
    getOnlineModeStatus({ commit, state }) {
      const url = `${urlMainAPI}/systemStatus`;
      if (state.user != null) {
        // console.log("User: " + state.user.FullName);
        axios.get(url).then((res) => {
          if (res) {
            if (this.state.changingStatus != 0) return;
            commit("setIsOnlineReady", res.data.onlineReady);

            if (!res.data.onlineReady) commit("setIsOnlineRunning", false);
            else commit("setIsOnlineRunning", res.data.onlineActive);

                            commit("setMaintenance", res.data.maintenance);
                            commit("setActiveModel", res.data.activeModel);
                            commit("setTriggerActive", res.data.triggerActive);
                            commit("setAutonomousMode", res.data.autonomousMode);
                        }
                    })
            }
        },
        startMonitoringSystemMessages({commit, state}) {
          if(state.intervals.systemMessages) {
            clearInterval(state.intervals.systemMessages);
            state.intervals.systemMessages = undefined;
          }
    
          let systemMessagesInterval = setInterval(() => {
            axios.get(`${urlMainAPI}/getallsystemeventmessages`).then((response) => {
                commit('setSystemMessages', response.data)
            }).catch((error) => {
                console.error('>> Get All System Event Messages', error)
            });
          }, 1000 * 15);
          state.intervals.systemMessages = systemMessagesInterval
        }
    }
});
